export const messages = {
    today: {
      key: 'Text.TODAY',
    },
};


